import { useState, type ReactNode } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

/** Choosing a report only changes presentation; both results belong to the same run. */
export function ReportViews({ shadow, gap }: { shadow: ReactNode; gap: ReactNode }) {
  const [view, setView] = useState('shadow');
  return (
    <Tabs variant='segmented' value={view} onValueChange={setView} className='flex flex-col gap-4'>
      <TabsList aria-label='Run reports' className='w-fit'>
        <TabsTrigger value='shadow'>Shadow</TabsTrigger>
        <TabsTrigger value='gap'>Gap</TabsTrigger>
      </TabsList>
      <TabsContent value='shadow'>{shadow}</TabsContent>
      <TabsContent value='gap'>{gap}</TabsContent>
    </Tabs>
  );
}
